$(document).ready(function () {
  $(".carousel-track-container").css({ display: "block" });
});

var slideIndexCarousel = 1;
showSlides(slideIndexCarousel);

function plusSlides(n) {
  showSlides((slideIndexCarousel += n));
}

function currentSlide(n) {
  showSlides((slideIndexCarousel = n));
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("carousel-slide");
  var dots = document.getElementsByClassName("carousel-indicator");
  if (n > slides.length) {
    slideIndexCarousel = 1;
  }
  if (n < 1) {
    slideIndexCarousel = slides.length;
  }
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[slideIndexCarousel - 1].style.display = "block";
  dots[slideIndexCarousel - 1].className += " active";
}

//carousel to be swiping automatically every 3 seconds
setInterval(function () {
  plusSlides(1);
}, 4000);
